<template>
  <div class="loginForm modal fade" id="printerModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-3"></column>
      <column class="col-md-6">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">Printer IP Address</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Printer IP Address" v-model="printerIP" />
                </div>
              </div>
              <div class="form-group" v-if="$root.isAdmin">
                <label class="col-sm-3 control-label">Dealer</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="dealerKey" style="padding-left: 0px;">
                    <option v-for="(item,index) in $root.dealers" :data="item" :key="index" :value="item.value">
                      {{ item.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-if="!$root.isCustomer">
                <label class="col-sm-3 control-label">Customer</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="customerKey" style="padding-left: 0px;">
                    <option v-for="(item,index) in dealerCustomers" :data="item" :key="index" :value="item.value">
                      {{ item.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Site</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="siteKey" style="padding-left: 0px;">
                    <option v-for="(item,index) in customerSites" :data="item" :key="index" :value="item.value">
                      {{ item.title }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" align="center">
                <va-alert type="danger" :dismissible="true" v-show="error" style="width: 98%;">
                  <div slot="body">
                    <i class="icon fa fa-ban"></i> {{error}}
                  </div>
                </va-alert>
              </div>
            </form>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
            <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="save" style="margin-right: 10px;"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-3"></column>
    </row>
  </div>
</template>
<script>
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'
  import VASelect from './VASelect'

  import { dbListener } from '../firebase'

  export default {
    name: 'AddPrinter',
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton,
      'va-select': VASelect
    },
    data () {
      return {
        printerIP: '',
        dealerKey: '',
        customerKey: '',
        siteKey: '',
        title: 'Add Printer',
        error: '',
        dealerCustomers: [],
        customerSites: []
      }
    },
    created () {
    },
    mounted () {
      this.$bus.$on('printerModal-open', (args) => {
        console.log(args)
        this.reset()
        if (this.$root.isAdmin) {
          this.dealerKey = ''
        } else if (this.$root.isDealer) {
          this.dealerKey = this.$root.user['.key']
        } else if (this.$root.isCustomer) {
          this.dealerKey = this.$root.filter.dealerKey
          this.customerKey = this.$root.filter.customerKey
        }
        this.title = 'Add Printer'
        $('#printerModal').modal('show')
      })
    },
    watch: {
      printerIP (val) {
        console.log('watch: printerIP = ' + val)
        this.error = ''
      },
      dealerKey (val) {
        console.log('watch: dealerKey = ' + val)
        this.initCustomers()
        this.error = ''
      },
      customerKey (val) {
        console.log('watch: customerKey = ' + val)
        this.initSites()
        this.error = ''
      }
    },
    methods: {
      initCustomers () {
        // dealerCustomers
        let vm = this
        vm.dealerCustomers = []
        if (vm.dealerKey === '') {
          // do nothing
        } else {
          for (let i = 0; i < vm.$root.customers.length; i++) {
            if (vm.$root.customers[i].dealerKey === vm.dealerKey) {
              vm.dealerCustomers.push(vm.$root.customers[i])
            }
          }
        }
        vm.customerKey = ''
      },
      initSites () {
        let vm = this
        vm.customerSites = []
        if (vm.customerKey === '') {
          // do nothing
        } else {
          for (let i = 0; i < vm.$root.sites.length; i++) {
            if (vm.$root.sites[i].customerKey === vm.customerKey) {
              vm.customerSites.push(vm.$root.sites[i])
            }
          }
        }
        vm.siteKey = ''
      },
      save () {
        let vm = this
        if (vm.isValid()) {
          // const printer = { PrinterIP: vm.printerIP }
          console.log('PrinterIP = ' + vm.printerIP)
          console.log('Dealer Key = ' + vm.dealerKey)
          console.log('Customer Key = ' + vm.customerKey)
          console.log('Site Key = ' + vm.siteKey)
          vm.updateClientAddPrinterIP()
          // vm.reset()
          // $('#printerModal').modal('hide')
        }
      },
      updateClientAddPrinterIP () {
        let vm = this
        console.log('updateClientAddPrinterIP(' + vm.printerIP + ')')
        dbListener.ref('UpdateClient/' + vm.siteKey + '/AddPrinters').once('value').then(function (snapData) {
          let strData = snapData.val()
          console.log('strData: ' + strData)
          if (strData) {
            let arr = strData.split(',')
            if (arr && arr.length > 0) {
              let index = arr.indexOf(vm.printerIP)
              if (index === -1) {
                arr.push(vm.printerIP)
                strData = arr.join(',')
                dbListener.ref('UpdateClient/' + vm.siteKey + '/AddPrinters').set(strData).then(function () {
                  console.log('AddPrinters [' + vm.printerIP + '] Was set to [Done].')
                  vm.close(vm)
                }).catch(function (error) {
                  console.log('Error: ' + error.message)
                  vm.error = error.message
                })
              } else {
                vm.close(vm)
              }
            }
          } else {
            dbListener.ref('UpdateClient/' + vm.siteKey + '/AddPrinters').set(vm.printerIP)
            vm.close(vm)
          }
        }).catch(function (error) {
          console.log('Error: ' + error.message)
          vm.error = error.message
        })
      },
      cancel () {
        this.reset()
        $('#printerModal').modal('hide')
      },
      isValid () {
        this.error = ''

        if (!this.printerIP || this.printerIP.length === 0) {
          this.error = '* Please enter Printer IP (Empty string)!'
          return false
        }

        var len1 = '1.1.1.1'.length
        var len255 = '255.255.255.255'.length
        var lenIP = this.printerIP.length
        console.log('len1 = ' + len1)
        console.log('len255 = ' + len255)
        console.log('lenIP = ' + lenIP)
        if (lenIP < len1 || lenIP > len255) {
          this.error = '* Please enter Correct Printer IP (length is ' + lenIP + ')!'
          return false
        }

        var numOfDots = this.printerIP.match(/\./g).length
        if (numOfDots !== 3) {
          this.error = '* Please enter Correct Printer IP (number of dots is ' + numOfDots + ')!'
          return false
        }

        var printerIPNoDots = this.printerIP.replace(/\./g, '')
        console.log('printerIPNoDots = ' + printerIPNoDots)
        if (isNaN(printerIPNoDots)) {
          this.error = '* Please enter Correct Printer IP (Use digits only from 1 to 254 in format: xxx.xxx.xxx.xxx)!'
          return false
        }

        var numsArr = this.printerIP.split('.')
        var len = numsArr.length
        if (len === 4) {
          for (var i = 0; i < len; i++) {
            if (isNaN(numsArr[i])) {
              this.error = '* Please enter Correct Printer IP (Use digits only from 1 to 254)!'
              return false
            } else {
              if (!(Number(numsArr[i]) >= 1 && Number(numsArr[i]) <= 254)) {
                this.error = '* Please enter Correct Printer IP (Use digits only from 1 to 254)!'
                return false
              }
            }
          }
        } else {
          this.error = '* Please enter Correct Printer IP (Use IP format: xxx.xxx.xxx.xxx)!'
          return false
        }

        if (!this.dealerKey || this.dealerKey.length === 0) {
          this.error = '* Unknown Dealer!'
          return false
        }

        if (!this.customerKey || this.customerKey.length === 0) {
          this.error = '* Please Select a Customer!'
          return false
        }

        if (!this.siteKey || this.siteKey.length === 0) {
          this.error = '* Please Select a Site!'
          return false
        }

        return true
      },
      close (vm) {
        vm.reset()
        $('#printerModal').modal('hide')
      },
      reset () {
        this.printerIP = ''
        this.siteKey = ''
        this.dealerKey = ''
        this.customerKey = ''
        this.totalPrinters = 0
        this.error = ''
      }
    }
  }

</script>



// WEBPACK FOOTER //
// AddPrinter.vue?482cef46